export var BuiltinType;
(function (BuiltinType) {
    BuiltinType["Value"] = "Value";
    BuiltinType["ValueObject"] = "ValueObject";
    BuiltinType["MemberValue"] = "MemberValue";
    BuiltinType["InstanceMemberValue"] = "InstanceMemberValue";
    BuiltinType["Call"] = "Call";
    BuiltinType["MemberCall"] = "MemberCall";
    BuiltinType["InstanceMemberCall"] = "InstanceMemberCall";
    BuiltinType["Template"] = "Template";
    BuiltinType["MemberTemplate"] = "MemberTemplate";
    BuiltinType["InstanceMemberTemplate"] = "InstanceMemberTemplate";
    BuiltinType["InstanceOf"] = "InstanceOf";
    BuiltinType["Interface"] = "Interface";
    BuiltinType["New"] = "New";
})(BuiltinType || (BuiltinType = {}));
export function isBuiltinInterface(value) {
    return value.types.has(BuiltinType.Interface);
}
export function isBuiltinValue(value) {
    return value.types.has(BuiltinType.Value);
}
export function isBuiltinMemberValue(value) {
    return value.types.has(BuiltinType.MemberValue);
}
export function isBuiltinInstanceMemberValue(value) {
    return value.types.has(BuiltinType.InstanceMemberValue);
}
export function isBuiltinCall(value) {
    return value.types.has(BuiltinType.Call);
}
export function isBuiltinTemplate(value) {
    return value.types.has(BuiltinType.Template);
}
export function isBuiltinMemberTemplate(value) {
    return value.types.has(BuiltinType.MemberTemplate);
}
export function isBuiltinInstanceMemberTemplate(value) {
    return value.types.has(BuiltinType.InstanceMemberTemplate);
}
export function isBuiltinMemberCall(value) {
    return value.types.has(BuiltinType.MemberCall);
}
export function isBuiltinInstanceMemberCall(value) {
    return value.types.has(BuiltinType.InstanceMemberCall);
}
export function isBuiltinInstanceOf(value) {
    return value.types.has(BuiltinType.InstanceOf);
}
export function isBuiltinNew(value) {
    return value.types.has(BuiltinType.New);
}
export function isBuiltinValueObject(value) {
    return value.types.has(BuiltinType.ValueObject);
}

//# sourceMappingURL=types.js.map
